import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles.scss";
import { Scrollbars } from "react-custom-scrollbars";
import * as actionTypes from "../../../store/actions/types";
import { Spin } from "antd";
import { userDetails, userLogOut } from "../../../utils";
import {
  getAdminUser,
  getOffer,
  getOfferByStatus,
  getSessionValidateStatus,
} from "../../../api";
import { Button, OfferCard } from "../../../components";
import { v4 as uuidv4 } from "uuid";
import {
  cooFindMerchantById,
  cooGetOfferByMerchant,
} from "../../merchant/service/merchant.service";
import { getAllDrafts } from "../../../api/draft";

class pending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPointWidth: 0,
      viewPointHeight: 0,
      isActiveShadow: false,
      isLoading: false,
      dataSource: [],
      pendingOffers: [],
      acceptedOffers: [],
      rejectedOffers: [],
      userDataSource: [],
      categoryOptions: [],
      pageNo: 1,
      pendingPageNo: 1,
      rejectPageNo: 1,
      acceptedTotalCount: 0,
      pendingTotalCount: 0,
      rejectedTotalCount: 0,
      pageViewCount: 10,
      dataForm: {
        searchOffer: {
          key: "searchOffer",
          elementType: "input",
          elementConfig: {
            type: "text",
            placeholder: "Search offer title here...",
          },
          value: "",
          validation: {
            required: false,
          },
          valid: false,
          touched: false,
          label: "",
        },
        keywords: {
          key: "keywords",
          elementType: "select",
          elementConfig: {
            type: "text",
            placeholder: "Search Merchant here...",
            options: [],
          },
          value: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "",
        },
      },
      tabJson: [
        {
          id: uuidv4(),
          key: 1,
          tabName: "Pending Offers",
          content: "",
        },
        {
          id: uuidv4(),
          key: 2,
          tabName: "Active Offers",
          content: "",
        },
        {
          id: uuidv4(),
          key: 3,
          tabName: "Rejected Offers",
          content: "",
        },
      ],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
    //window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log("scrollTop : " + scrollTop);
    //console.log("scrollHeight : " + scrollHeight);
    //console.log("clientHeight :" + clientHeight);
  };

  async componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);
    await this.getAll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  async getAll() {
    let sessionStatus = await getSessionValidateStatus();
    console.log("sessionStatus", sessionStatus);
    if (sessionStatus?.data?.status) {
      this.setState({ isLoading: true });
      let user = await userDetails();
      if (user && user.userId) {
        // let resOffer = await getOffer();

        let resOffersAccept = await getAllDrafts();
        console.log("getAllDrafts", resOffersAccept);

        const offersDataAccept = await this.resetOffers(
          resOffersAccept && resOffersAccept.data,
          user
        );

        let acceptedTotalCount = offersDataAccept?.length || 0;

        this.setState((prevState) => ({
          ...prevState,
          acceptedOffers: offersDataAccept || [],
          acceptedTotalCount,
          user: user,
          isLoading: false,
        }));
        this.props.doneRefresh();
      }
    } else {
      userLogOut();
      this.props.history.push("/sign-in");
    }
  }

  async getOffersByMerchant(merchantId) {
    this.setState({ isLoading: true });
    let user = await userDetails();
    if (user && user.userId && merchantId) {
      const resOfferByMerchant = await cooGetOfferByMerchant(merchantId);
      console.log("resOfferByMerchant", resOfferByMerchant);
      if (
        resOfferByMerchant &&
        resOfferByMerchant.data &&
        resOfferByMerchant.data.status
      ) {
        const offersDataNew = resOfferByMerchant?.data?.data;

        let pendingTotalCount = resOfferByMerchant?.data?.totalCount || 0;

        this.setState((prevState) => ({
          ...prevState,
          pendingOffers: offersDataNew || [],
          pendingTotalCount,
          isLoading: false,
        }));
      } else {
        this.setState({
          isLoading: false,
        });
      }
    } else {
      await this.getAll();
    }
  }

  async resetOffers(offerList, user) {
    let resetList = [];
    if (user?.userType != "user") {
      resetList = offerList;
    } else {
      offerList.forEach((element) => {
        if (user?.userType === "user" && user?.userId === element?.userId) {
          resetList.push(element);
        }
      });
    }
    return resetList;
  }

  // pushAcceptedItems = async () => {
  //   let resOffersAccept = await getOfferByStatus(
  //     this.state.pageNo + 1,
  //     10,
  //     "accepted"
  //   );
  //   const acceptedItems = await this.resetOffers(
  //     resOffersAccept && resOffersAccept.data,
  //     this.state.userDataSource
  //   );
  //   this.setState((prevState) => ({
  //     acceptedOffers: [...prevState.acceptedOffers, ...acceptedItems],
  //     pageNo: prevState.pageNo + 1,
  //   }));
  // };

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.searchOfferTitle !== this.props.searchOfferTitle) {
      let updateDataForm = this.state.dataForm;
      updateDataForm.searchOffer.value = this.props.searchOfferTitle;
      this.setState({ dataForm: updateDataForm });
    }

    if (prevProps.refreshOffers !== this.props.refreshOffers) {
      this.setState({ isLoading: true });
      await this.getAll();
      if (!this.state.isLoading) {
        this.props.doneRefresh();
      }
    }

    if (prevProps.selectMerchantId !== this.props.selectMerchantId) {
      this.setState({ isLoading: true });
      if (this.props.selectMerchantId !== "") {
        await this.getOffersByMerchant(this.props.selectMerchantId);
      } else {
        await this.getAll();
      }
    }

    if (prevProps.refreshDrafts !== this.props.refreshDrafts) {
      if (this.props.refreshDrafts) {
        this.setState((prevState) => ({ ...prevState, isLoading: true }));
        await this.getAll();
      }
    }
  }

  render() {
    const { viewPointHeight, acceptedOffers, isLoading, dataForm } = this.state;
    const { editOfferData } = this.props;

    return (
      <>
        <div
          style={{
            paddingRight: "24px",
            paddingBottom: "24px",
            paddingLeft: "24px",
          }}
        >
          {isLoading && (
            <div style={{ margin: "10% 50%" }}>
              <Spin size="large" spinning={isLoading} />
            </div>
          )}
          {!isLoading && (
            <>
              {/* Accepted offers */}
              <div>
                <Scrollbars
                  style={{ height: viewPointHeight - 290 }}
                  thumbMinSize={30}
                  universal={true}
                  autoHide
                >
                  {acceptedOffers && acceptedOffers.length > 0 && (
                    <>
                      {acceptedOffers
                        .filter((item) => {
                          if (dataForm.searchOffer.value === "") {
                            return item; // Corrected the return statement
                          } else if (
                            item.header
                              ?.toLowerCase()
                              .includes(
                                dataForm.searchOffer.value.toLowerCase()
                              )
                          ) {
                            return item; // Corrected the return statement
                          }
                        })
                        .map((item, index) => (
                          <OfferCard
                            draftId={item && item?.draftId}
                            offerId={item && item?.offerId}
                            isActive={editOfferData?.offerId === item?.offerId}
                            details={item && item.header}
                            name={
                              item &&
                              item.merchant &&
                              item.merchant.merchantName
                            }
                            type={"draft"}
                            bankName={item && item.bank && item.bank.bankName}
                            logo={item && item.bank && item.bank.logoURL}
                            imgUrl={item.bannerImageURL}
                            userName={item && item?.user?.firstName}
                            categoryName={item && item?.category?.categoryName}
                            offerEndDate={item && item.offerEnd}
                            createAt={item && item.createdAt}
                            status={
                              item &&
                              item?.status?.charAt(0).toUpperCase() +
                                item?.status?.slice(1)
                            }
                            onClickViewOffer={() =>
                              this.props.onClickOpenOfferView(item)
                            }
                            onClickEdit={async () => {
                              this.props.onClickClearSelected();
                              // this.props.onClickSelectOffer(item);
                              this.props.setCreateOfferData({
                                draftOffer: item,
                                selectOffer: item,
                                selectedMerchant: item.merchant,
                                selectedBank: item.bank,
                                selectedCategory: item.category,
                                selectLocations: item.location,
                                selectTerms: item.termsConditions,
                              });
                              let resMerchant = await cooFindMerchantById(
                                item.merchantId
                              );
                              let merchant = resMerchant?.data?.data;
                              console.log({ merchant });
                              this.props.onClickSelectedMerchant({
                                ...item?.merchant,
                                termsAndCondition: merchant.termsAndCondition,
                              });
                            }}
                          />
                        ))}
                    </>
                  )}
                  {/* {!isLoading &&
                    this.state.acceptedTotalCount -
                      this.state.pageNo * this.state.pageViewCount >
                      0 && (
                      <div
                        className={
                          "console__load-more-wrp d-flex justify-content-center mt-3 "
                        }
                      >
                        <Button
                          size={"sm"}
                          type={"btn-primary light"}
                          isLoading={isLoading}
                          onClick={async () => {
                            if (acceptedOffers?.length > 0) {
                              // await this.pushAcceptedItems();
                            }
                          }}
                          text={`Load more offers (${
                            this.state.acceptedTotalCount -
                            this.state.pageNo * this.state.pageViewCount
                          })`}
                        />
                      </div>
                    )} */}
                  {this.state.isLoading && (
                    <div style={{ margin: "0 50%", opacity: 0.5 }}>
                      <Spin size="large" spinning={isLoading} />
                    </div>
                  )}
                </Scrollbars>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userReducer.userData,
  refreshDrafts: state.offerReducer.refreshDrafts,
  editOfferData: state.offerReducer.editOfferData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onClickClearSelected: () =>
      dispatch({ type: actionTypes.CLEAR_OFFER_DETAILS }),
    onClickSelectOffer: (data) =>
      dispatch({ type: actionTypes.VIEW_OFFER_DETAILS, payload: data }),
    onClickOpenOfferView: (payload) =>
      dispatch({
        type: actionTypes.OPEN_OFFER_VIEW_MODAL,
        payload: payload,
      }),
    setCreateOfferData: (data) =>
      dispatch({ type: actionTypes.CREATE_OFFER_DETAILS, payload: data }),
    onClickSelectedMerchant: (payload) =>
      dispatch({ type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL, payload }),

    doneRefresh: () =>
      dispatch({
        type: actionTypes.DONE_REFRESH_OFFERS,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(pending);
